import React, { useState, useRef, useContext } from 'react';
import { AppContext } from '../util/AppContext';
import { getConfigValue } from '../util/getConfigValue';
import PropType from 'prop-types';
import Tooltip from './Tooltip';
import { planListIconType } from '../util/constants';

PlanListInlineIcon.propTypes = {
	isSelected: PropType.bool,
	iconType: PropType.string,
	onClick: PropType.func,
	showIcon: PropType.bool,
	index: PropType.number,
	enabled: PropType.bool,
}

function PlanListInlineIcon({ isSelected, iconType, onClick, showIcon, index, enabled }) {
	const [showTooltip, setShowTooltip] = useState(false);
	const tooltipTarget = useRef(null);
	const [appState] = useContext(AppContext);
	let tooltipText = '';
	let iconClassName = '';

	switch (iconType) {
		case planListIconType.Formulary:
			tooltipText =  isSelected
				? getConfigValue(appState.config?.PlanList?.InlineIcons?.Formulary?.Selected?.Tooltip, appState)?.Value
				: getConfigValue(appState.config?.PlanList?.InlineIcons?.Formulary?.Unselected?.Tooltip, appState)?.Value;
			iconClassName = isSelected ? 'fa-solid fa-circle-f' : 'fa-regular fa-circle-f';
			break;
		case planListIconType.SpecialtyPharmacy:
			tooltipText = isSelected
				? getConfigValue(appState.config?.PlanList?.InlineIcons?.SpecialtyPharmacies?.Selected?.Tooltip, appState)?.Value
				: getConfigValue(appState.config?.PlanList?.InlineIcons?.SpecialtyPharmacies?.Unselected?.Tooltip, appState)?.Value;
			iconClassName = isSelected ? 'fa-solid fa-circle-s' : 'fa-regular fa-circle-s';
			break;
		case planListIconType.RestrictionNotes:
			tooltipText = isSelected
				? getConfigValue(appState.config?.PlanList?.InlineIcons?.RestrictionNotes?.Selected?.Tooltip, appState)?.Value
				: getConfigValue(appState.config?.PlanList?.InlineIcons?.RestrictionNotes?.Unselected?.Tooltip, appState)?.Value;
			iconClassName = isSelected ? 'fa-solid fa-circle-r' : 'fa-regular fa-circle-r';
			break;
		default:
			break;
	}

	return (
		<>
			{showIcon && (
				<>
					<button
						ref={tooltipTarget}
						className={`${iconClassName} ${enabled ? '' : 'disabled'}`}
						onClick={onClick}
						onMouseOver={() => setShowTooltip(true)}
						onFocus={() => setShowTooltip(true)}
						onMouseOut={() => setShowTooltip(false)}
						onBlur={() => setShowTooltip(false)}
						aria-label={tooltipText}
					></button>
					<Tooltip text={tooltipText} placement='top' ref={tooltipTarget} showTooltip={showTooltip} index={index} />
				</>
			)}
		</>
	);
}

export default PlanListInlineIcon;
